if (!customElements.get('condition-grade')) {
  customElements.define(
    'condition-grade',
    class ConditionGrade extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Find button by ID pattern (handles both static and dynamic IDs)
        const button = this.querySelector('[id^="ShowConditionGradeDrawer"]');
        const drawer = this.querySelector('condition-grade-drawer');

        if (button && drawer) {
          button.addEventListener('click', () => {
            drawer.show();
          });
        }
      }
    }
  );
}

// Global function to open any condition grade drawer by section ID or drawer element
window.openConditionGradeDrawer = function(sectionId) {
  let drawer = null;
  
  if (sectionId && sectionId.trim() !== '') {
    // Try multiple methods to find the drawer
    // 1. Find by data-drawer-id attribute
    drawer = document.querySelector(`condition-grade-drawer[data-drawer-id="${sectionId}"]`);
    
    // 2. Find by ID
    if (!drawer) {
      drawer = document.querySelector(`#ConditionGradeDrawer-${sectionId}`);
    }
    
    // 3. Find within section container
    if (!drawer) {
      const section = document.querySelector(`[id*="${sectionId}"]`);
      if (section) {
        drawer = section.querySelector('condition-grade-drawer');
      }
    }
  } else {
    // If no section ID provided, find first Condition Grade Info section drawer
    drawer = document.querySelector('condition-grade-drawer[data-drawer-id]');
  }
  
  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
  } else {
    console.warn('Condition Grade Drawer not found. Make sure you have added the "Condition Grade Info" section to your product page.');
  }
};

if (!customElements.get('condition-grade-drawer')) {
  customElements.define(
    'condition-grade-drawer',
    class ConditionGradeDrawer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.closeButton = this.querySelector('.condition-grade-drawer-button');
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.hide.bind(this));
        }

        this.addEventListener('keyup', (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') {
            this.hide();
          }
        });

        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.hide();
          }
        });
      }

      show() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        
        // Create backdrop
        if (!this.backdrop) {
          this.backdrop = document.createElement('div');
          this.backdrop.className = 'drawer-backdrop';
          this.backdrop.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 12;';
          this.backdrop.addEventListener('click', this.hide.bind(this));
          document.body.appendChild(this.backdrop);
        }
        
        this.focus();
      }

      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        
        // Remove backdrop
        if (this.backdrop) {
          this.backdrop.remove();
          this.backdrop = null;
        }
      }
    }
  );
}

